import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BASE_URL from '../config';
import Swal from 'sweetalert2';
import SidebarRFQ from '../POpage/SidebarRFQ';
import Sidebarpo from './Sidebarpo';





const SupplierList = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [supplierForm, setSupplierForm] = useState({ id: null, name: '', email: '', phone: '', location: '' });
  const [editMode, setEditMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const user = JSON.parse(localStorage.getItem("userdata"));


  useEffect(() => {
    fetchSuppliers();
  }, []);

  const fetchSuppliers = () => {
    axios.get(`${BASE_URL}/api/supplier-get`)
      .then(res => setSuppliers(res.data))
      .catch(() => Swal.fire('Error', 'Failed to load suppliers', 'error'));
  };

  const handleOpenModal = (supplier = null) => {
    setEditMode(!!supplier);
    setSupplierForm(supplier || { id: null, name: '', email: '', phone: '', location: '' });
    window.$('#supplierModal').modal('show');
  };

  const handleChange = (e) => {
    setSupplierForm({ ...supplierForm, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const { id, name } = supplierForm;
    if (!name.trim()) {
      Swal.fire('Error', 'Supplier name is required', 'error');
      return;
    }

    const method = editMode ? axios.put : axios.post;
    const url = `${BASE_URL}/api/${editMode ? `supplier-update/${id}` : 'supplier-add'}`;

    method(url, supplierForm)
      .then(() => {
        Swal.fire('Success', `Supplier ${editMode ? 'updated' : 'added'} successfully!`, 'success');
        fetchSuppliers();
        window.$('#supplierModal').modal('hide');
      })
      .catch(() => Swal.fire('Error', 'Failed to save supplier', 'error'));
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This supplier will be permanently deleted.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${BASE_URL}/api/supplier-delete/${id}`)
          .then(() => {
            Swal.fire('Deleted!', 'Supplier has been deleted.', 'success');
            fetchSuppliers();
          })
          .catch(() => Swal.fire('Error', 'Failed to delete supplier', 'error'));
      }
    });
  };

  // Pagination
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentData = suppliers.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(suppliers.length / itemsPerPage);

  const getPaginationGroup = () => {
    let start = Math.floor((currentPage - 1) / 5) * 5;
    return new Array(Math.min(5, totalPages - start)).fill().map((_, i) => start + i + 1);
  };

  return (
    <div className='row'>
      <div className="custom-2-5">

              <Sidebarpo />
              </div>
      <div className="custom-9-5 dashboardsclooer p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>SUPPLIER LIST</h5>
          <button className="btn btncolor" onClick={() => handleOpenModal()}>+ New Supplier</button>
        </div>

        <div className="table-responsive" style={{ background: '#fff' }}>
          <table className="table table-borderless custom-table">
            <thead>
              <tr>
                <th> Supplier Name</th>
                <th> Supplier Email</th>
                <th> Supplier Phone</th>
                <th> SupplierLocation</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map(supplier => (
                <tr key={supplier.id}>
                  <td>{supplier.name}</td>
                  <td>{supplier.email || '-'}</td>
                  <td>{supplier.phone || '-'}</td>
                  <td>{supplier.location || '-'}</td>
                  <td>
                    <button className="btn btn-sm btn-outline-primary mr-2" onClick={() => handleOpenModal(supplier)}>Edit</button>
                    {user.deletestatus === "1" && (

                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(supplier.id)}>Delete</button>
                    )}
                  </td>
                </tr>
              ))}
              {currentData.length === 0 && (
                <tr><td colSpan="5" className="text-center">No suppliers found</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="mt-3 d-flex justify-content-center">
            <nav>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>&laquo;</button>
                </li>
                {getPaginationGroup().map((pageNumber) => (
                  <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(pageNumber)}>{pageNumber}</button>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>&raquo;</button>
                </li>
              </ul>
            </nav>
          </div>
        )}

        {/* Modal */}
        <div className="modal fade" id="supplierModal" tabIndex="-1" role="dialog" aria-labelledby="supplierModalLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editMode ? 'Edit Supplier' : 'New Supplier'}</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {['name', 'email', 'phone', 'location'].map(field => (
                  <div className="form-group" key={field}>
                    <label>{field.charAt(0).toUpperCase() + field.slice(1)}</label>
                    <input
                      type="text"
                      className="form-control"
                      name={field}
                      value={supplierForm[field]}
                      onChange={handleChange}
                      placeholder={`Enter ${field}`}
                    />
                  </div>
                ))}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                  {editMode ? 'Update Supplier' : 'Add Supplier'}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* End Modal */}
      </div>
    </div>
  );
};

export default SupplierList;
